import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-4 p-4 sm:p-6 lg:p-8"
}
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 sm:grid-cols-2"
}

import { ref, Ref, computed, ComputedRef, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { AxiosError } from 'axios';

import { useAuthStore, useUiStore } from '@/stores';
import CallService from '@/services/api/CallService';
import { toastServiceError } from '@/services/core/notification';

import {
    CallModel,
    CallType,
    CallParticipantType,
    DefaultServiceResult,
    UserIntegrationModel,
} from '@/types';

import {
    CallDetails,
    CallPlayer,
    CallWords,
    CallSurvey,
    CallChatBot,
} from '@/views/pages/call/components';


export default /*@__PURE__*/_defineComponent({
  __name: 'CallDetailPage',
  setup(__props) {

const route = useRoute();
const uiStore = useUiStore();
const authStore = useAuthStore();

const call: Ref<CallModel | null> = ref(null);

const isLoading = computed(() => uiStore.isLoading);

const chatBotIntegration: ComputedRef<UserIntegrationModel | undefined> = computed(
    () => authStore.chatBotIntegration,
);

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const getCall = async (id: number) => {
    await setLoading(true);
    try {
        const response = await CallService.get<CallModel>(id);
        call.value = response.data;
    } catch (err) {
        toastServiceError(err as Error | AxiosError<DefaultServiceResult>);
    } finally {
        await setLoading(false);
    }
};

onMounted(async () => {
    await getCall(Number(route.params.id));
});

return (_ctx: any,_cache: any) => {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!

  return (call.value !== null && !isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_UiPageHeader, null, {
          info: _withCtx(() => [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('core.entity.Call')), 1)
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_UiBackButton, { fallbackTo: { name: 'CallList' } })
          ]),
          _: 1
        }),
        _createVNode(_unref(CallDetails), {
          call: call.value,
          "show-view-button": false,
          "show-download-button": ""
        }, null, 8, ["call"]),
        _createVNode(_unref(CallPlayer), { call: call.value }, null, 8, ["call"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(CallWords), {
            call: call.value,
            participantType: 
                    call.value.type === _unref(CallType).INTERNAL
                        ? _unref(CallParticipantType).AgentA
                        : _unref(CallParticipantType).Agent
                
          }, null, 8, ["call", "participantType"]),
          _createVNode(_unref(CallWords), {
            call: call.value,
            participantType: 
                    call.value.type === _unref(CallType).INTERNAL
                        ? _unref(CallParticipantType).AgentB
                        : _unref(CallParticipantType).Client
                
          }, null, 8, ["call", "participantType"])
        ]),
        (call.value.surveyAnswers !== undefined && call.value.surveyAnswers.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(CallSurvey), {
                surveyCallAnswer: call.value.surveyAnswers,
                survey: call.value.survey
              }, null, 8, ["surveyCallAnswer", "survey"])
            ]))
          : _createCommentVNode("", true),
        (chatBotIntegration.value)
          ? (_openBlock(), _createBlock(_unref(CallChatBot), {
              key: 1,
              call: call.value
            }, null, 8, ["call"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})